export default {_name:'image',module:'Field',view:'Element/Image',options:{key:'image',ms:8,sm:8,xs:12}}